import { useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useBoundStore } from '../../../state/bound.store'
export const useGetChatName = (rcChannelID: string) => {
    const { channels, users, user } = useBoundStore(
        useShallow((s) => {
            return {
                users: s.users,
                channels: s.rocketchannels[s.selectedItinID],
                user: s.wpUser,
            }
        })
    )
    const channel = useMemo(() => {
        if (!rcChannelID) return null
        const channel = channels?.find((c) => c.channel_id === rcChannelID)
        if (!channel) return null
        return channel
    }, [rcChannelID, channels])

    if (!channel) return ''

    if (channel.type === 'direct') {
        const otherUserId = channel.members?.find((u) => u !== user?.id)
        return users?.find((u) => u.id === otherUserId)?.firstName
    } else {
        return channel.json_data.channel_name_parts
            .map((c) => c.replaceAll('_', ' '))
            .join(' ')
    }
}
